export var AGENCIES = 'setAgencies'
export var AGENCY = 'setAgency'
export var ASSIGNMENTS = 'setAssignments'
export var BOARDINGS = 'setBoardings'
export var COMMISSIONABLE = 'setCommissionable'
export var DATA = 'setData'
export var DEPARTURE = 'setDepartures'
export var DEPARTURES = 'setDepartures'
export var EMAIL = 'setEmail'
export var HOST = 'setHost'
export var HOTELS = 'setHotels'
export var ID = 'setId'
export var INFOAS = 'setInfoas'
export var INFOASCB = 'setInfoascb'
export var KIDS = 'setKids'
export var LOADING = 'setLoading'
export var LOGED = 'setLoged'
export var NAME = 'setName'
export var OCCUPATION = 'setOccupation'
export var PASSENGERS = 'setPassengers'
export var PREVIEWS = 'setPreviews'
export var PRICE = 'setPrice'
export var RATE = 'setRate'
export var RESERVATION = 'setReservation'
export var RESERVATIONS = 'setReservations'
export var REVOCATIONS = 'setRevocations'
export var ROOMING = 'setRooming'
export var SEATS = 'setSeats'
export var STATUS = 'setStatus'
export var STEP = 'setStep'
export var FINANCING = 'setFinancing'
export var BUDGET = 'setBudget'
export var NOTES = 'setNotes'
export var CODE = 'setCode'
export var COUNTDOWN = 'setCountdown'
export var TIMER = 'setTimer'
